var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrandingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 13.3334C8.3335 11.9501 8.3335 10.8334 10.8335 10.8334H14.1668C16.6668 10.8334 16.6668 10.0001 16.6668 8.33341V6.66675C16.6668 5.00008 16.6668 4.16675 14.1668 4.16675H13.3335",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 13.3334C8.3335 11.9501 8.3335 10.8334 10.8335 10.8334H14.1668C16.6668 10.8334 16.6668 10.0001 16.6668 8.33341V6.66675C16.6668 5.00008 16.6668 4.16675 14.1668 4.16675H13.3335",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 1.66675H6.6665C6.12484 3.29175 6.12484 5.04175 6.6665 6.66675H9.99984C10.5415 5.04175 10.5415 3.29175 9.99984 1.66675Z",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66683 1.66675H5.8335C4.16683 1.66675 3.3335 2.50008 3.3335 4.16675C3.3335 5.83341 4.16683 6.66675 5.8335 6.66675H6.66683C5.8335 5.00008 5.8335 3.33341 6.66683 1.66675Z",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 1.66675H10C10.8333 3.33341 10.8333 5.00008 10 6.66675H10.8333C12.5 6.66675 13.3333 5.83341 13.3333 4.16675C13.3333 2.50008 12.5 1.66675 10.8333 1.66675Z",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9165 18.3333H8.74984C9.99984 18.3333 9.99984 17.4999 9.99984 17.0833V14.5833C9.99984 14.1666 9.99984 13.3333 8.74984 13.3333H7.9165C6.6665 13.3333 6.6665 14.1666 6.6665 14.5833V17.0833C6.6665 17.4999 6.6665 18.3333 7.9165 18.3333Z",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandingIcon);
export default __webpack_public_path__ + "static/media/branding-icon.97cacae7bc01efc3d9903ad8ed3b9c64.svg";
export { ForwardRef as ReactComponent };